import { useState, useRef } from 'react';
import classnames from 'classnames';

import { ReactComponent as CloudSVG } from 'icons/cloud-arrow-up.svg';

import { getBytes } from 'helpers/files';
import './upload.scss';

const Upload = ({ value, label, accept, valid, onFileUpload }) => {
  const [files, setFiles] = useState(null);
  const inputFileRef = useRef(null);

  const onClick = () => {
    inputFileRef.current.click();
  };

  const onDrop = async (e) => {
    const droppedFiles = e.target.files;
    const fileList = [];

    await Promise.all(
      Object.keys(droppedFiles).map((index) => {
        return new Promise((resolve) => {
          const reader = new FileReader();
          const file = droppedFiles[index];

          reader.onload = () => {
            fileList.push({
              name: file.name,
              size: file.size,
              file,
              body: accept === 'image/*' ? reader.result : null,
            });

            setFiles(fileList);
            resolve();
          };

          reader.readAsDataURL(file);
        });
      }),
    );

    onFileUpload(fileList);
  };

  let preview;

  if (files) {
    if (accept === 'image/*') {
      preview = <img src={files[0].body} alt="preview" />;
    } else {
      preview = (
        <ul>
          {files.map((f, i) => (
            <li key={i}>
              <h3 className="f7 midgrey-d1">{f.name}</h3>
              <p>{getBytes(f.size)}</p>
            </li>
          ))}
        </ul>
      );
    }
  } else {
    preview = value ? (
      <img src={value} alt="preview" />
    ) : (
      <div className="attachment-placeholder">
        <CloudSVG />
        <p>Click here to browse</p>
      </div>
    );
  }

  const attachmentClasses = classnames('attachment', {
    error: !valid,
  });

  return (
    <div className="input-group">
      <label>{label}</label>
      <div className={attachmentClasses}>
        <section>
          <div className="dropzone" onClick={onClick}>
            <input
              type="file"
              accept={accept}
              ref={inputFileRef}
              style={{ display: 'none' }}
              onChange={onDrop}
            />
            {preview}
          </div>
          {!valid && (
            <span style={{ float: 'left' }} className="error">
              This question is required!
            </span>
          )}
        </section>
      </div>
    </div>
  );
};

export default Upload;
